import styled from "styled-components";
import { ContentProps } from "../Content";
import Editor from "./editor";

const Text = ({ id }: ContentProps.CommonProps) => {
  return (
    <MaxWidthContainer>
      <Editor id={id} />
    </MaxWidthContainer>
  );
};

export default Text;

const MaxWidthContainer = styled.div`
  position: relative;
  max-width: 906px;
  width: 100%;
`;
